import React, { useState, useEffect } from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { SearchBar as FiverrSearchBar } from '@fiverr-private/search_bar';
import { SUBMIT_BUTTON_TYPE } from '@fiverr-private/search_bar/src/utils/constants';
import { useIsMobileLayout } from '../../shared/hooks/useIsMobileLayout';
import SearchAnimatedPlaceholder from '../SearchAnimatedPlaceholder';
import {
  PLACEHOLDERS,
  MOBILE_PLACEHOLDERS,
  SEARCH_SOURCE,
  DESKTOP_STATIC_PLACEHOLDER,
  MOBILE_STATIC_PLACEHOLDER,
  MOBILE_WIDTH_BREAKPOINT,
} from './constants';
import { customSearchBarClass as customSearchBarClassDefault } from './styles.ve.css';
import { customSearchBarClass as customSearchBarClassV16 } from './styles_v16.ve.css';

const SearchBar: React.FC<{ isV16?: boolean }> = ({ isV16 = false }) => {
  const isMobile = useIsMobileLayout();
  const getStaticPlaceholders = () => {
    if (isMobile) {
      return MOBILE_STATIC_PLACEHOLDER;
    }
    return DESKTOP_STATIC_PLACEHOLDER;
  };

  const [hasInputValue, setHasInputValue] = useState(false);
  const [isTouched, setIsTouched] = useState(isV16);
  const [placeholders, setPlaceholders] = useState(isV16 ? getStaticPlaceholders() : PLACEHOLDERS);
  const customSearchBarClass = isV16 ? customSearchBarClassV16 : customSearchBarClassDefault;

  const handleSearch = (search: string) => {
    setIsTouched(true);
    const hasValue = Boolean(search && search.trim().length > 0);
    setPlaceholders(
      window.innerWidth < MOBILE_WIDTH_BREAKPOINT ? MOBILE_STATIC_PLACEHOLDER : DESKTOP_STATIC_PLACEHOLDER
    );
    setHasInputValue(hasValue);
  };

  useEffect(() => {
    const handleResize = () => {
      if (isTouched) {
        return;
      }

      if (window.innerWidth < MOBILE_WIDTH_BREAKPOINT) {
        setPlaceholders(MOBILE_PLACEHOLDERS);
      } else {
        setPlaceholders(PLACEHOLDERS);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isTouched]);

  return (
    <Stack
      className={customSearchBarClass}
      data-search-bar="brand"
      marginX="auto"
      marginTop="0"
      marginBottom="7"
      justifyContent="center"
      alignItems="center"
    >
      <Container
        position="relative"
        height={{
          default: '68px',
          sm: '76px',
          md: '88px',
        }}
        flexGrow={1}
      >
        {!hasInputValue && <SearchAnimatedPlaceholder placeholders={placeholders} isTouched={isTouched} />}

        <FiverrSearchBar
          placeholder=""
          submitButtonType={SUBMIT_BUTTON_TYPE.BUTTON_INSIDE}
          onSearch={handleSearch}
          dimBackgroundEnabled={false}
          submitOnSuggestionSelected={true}
          submitOnEnter={true}
          source={SEARCH_SOURCE}
        />
      </Container>
    </Stack>
  );
};

export default SearchBar;
